import { useEffect, useState } from 'react'

import { EModalType } from '../enums'

let setModalState: ((modal: EModalType | null) => void) | null = null

export const openModal = (modal: EModalType): void => {
  setModalState?.(modal)
}

export const closeModal = (): void => {
  setModalState?.(null)
}

export const useModal = () => {
  const [activeModal, setActiveModal] = useState<EModalType | null>(null)

  useEffect(() => {
    setModalState = setActiveModal
    return () => {
      setModalState = null
    }
  }, [])

  return activeModal
}
